import NavBar from '../../components/nav-bar/nav-bar'
import translate from '../../i18n'
import { Space } from 'antd'
import { Outlet, useLocation } from 'react-router-dom'

const PlanSubscriptionsContainer = () => {
  const location = useLocation()
  const isDetailsPage = /^\/plan-subscriptions\/\d+$/.test(location.pathname)

  return (
    <Space className="dashboard-wrapper" orientation="vertical">
      <NavBar
        title={translate(
          isDetailsPage ? 'planSubscriptions.detailTitle' : 'navBar.planSubscriptionsTitle',
        )}
      />
      <Outlet />
    </Space>
  )
}

export default PlanSubscriptionsContainer
